export default function SFUploadIcon({}) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 3.86667L16 19.7333M21.5714 7.6L16 2L10.4286 7.6M3 16.9333V26.2667C3 28.3285 4.66294 30 6.71429 30H25.2857C27.3371 30 29 28.3285 29 26.2667V16.9333"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
